export const tokenAddress='0xea838d33A6f2a63Af9f275e4197fd26E07aa1A06'
export const stakingAddress='0xb8778CE2D56c3B19169A4ed272FDC0928Cd6468C'